<template>
    <div id="tool-icons">
        <a id="btn-toggle-pen-options"
           class="btn-main-func icon-options"
           :class="classIsActive(TOOL_BRUSH)"
           :style="data.stylePenIcon"
           :title="i18n.t('tooltip_brush')"
           @click.prevent="setActiveTool(TOOL_BRUSH)"
           href="#"
        >
        </a>
        <a id="btn-toggle-highlighter-options"
           class="btn-main-func icon-options"
           :class="classIsActive(TOOL_HIGHLIGHTER)"
           :style="data.styleHighlighterIcon"
           :title="i18n.t('tooltip_highlighter')"
           @click.prevent="setActiveTool(TOOL_HIGHLIGHTER)"
           href="#"
        >
        </a>
        <a id="btn-toggle-note-options"
           class="btn-main-func icon-options"
           :class="data.classNote"
           :title="i18n.t('tooltip_notes')"
           @click.prevent="setActiveTool(TOOL_NOTE)"
           href="#"
        >
        </a>
        <a id="btn-toggle-eraser-options"
           class="btn-main-func icon-options"
           :class="classIsActive(TOOL_ERASER)"
           :title="i18n.t('tooltip_eraser')"
           @click.prevent="setActiveTool(TOOL_ERASER)"
           href="#"
        >
        </a>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch, inject}  from "vue"
    import {useTool} from "@/modules/reader/tools/tools";
    import {replaceDefaultTouchBehavior, restoreDefaultTouchBehavior}  from "@/modules/utils/touchUtils";
    import {toolState} from "../../../modules/reader/tools/tools";
    import config from "@/config/config.json";

    export default {
        setup(props, context) {

            const i18n = inject('i18n');

            const {
                toolState,
                togglePanel,
                TOOL_BRUSH,
                TOOL_HIGHLIGHTER,
                TOOL_NOTE,
                TOOL_ERASER
            } = useTool();

            //TODO: clean: please clean: move all const to data, and try to see if possible not to repeat in FooterReader.vue
            const data = reactive({
                stylePenIcon:computed(()=>{
                    let index = config.reader.tool.colors.indexOf(toolState.brushSetting.color);
                    return {
                        backgroundPosition: `${-36 * index}px 0`
                    }
                }),
                styleHighlighterIcon:computed(()=>{
                    let index = config.reader.tool.colors.indexOf(toolState.highlightSetting.color);
                    return {
                        backgroundPosition: `${-36 * index}px -36px`
                    }
                }),
                classNote: computed(()=>{
                    return {
                        active: (toolState.activeTool === TOOL_NOTE && toolState.isShowPanel) ? true : false,
                        disabled: toolState.isNoteDisabled
                    }
                })
            });

            const classIsActive = (currentTool)=>{
                //return (toolState.activeTool === currentTool ) ?  "active" : "";
                return (toolState.activeTool === currentTool && toolState.isShowPanel) ?  "active" : "";
            }

            const setActiveTool = (currentTool)=>{
                if (toolState.activeTool === currentTool|| !toolState.isShowPanel ) {
                    togglePanel();
                }
                toolState.activeTool = currentTool;
                toolState.isAllowed = true;

                if (currentTool !== TOOL_NOTE) {
                    replaceDefaultTouchBehavior();
                }

            }


            return {
                i18n,
                toolState,
                data,
                TOOL_BRUSH,
                TOOL_HIGHLIGHTER,
                TOOL_NOTE,
                TOOL_ERASER,
                classIsActive,
                setActiveTool
            }

        }
    }

</script>

<style scoped lang="scss">
    #tool-icons {

        display:flex;
        padding: 7px;
        background:$color-primary-deeper;
        border-radius: 6px;
        white-space: nowrap;
        -webkit-box-shadow: 0 4px 8px 0 rgba(0,0,0,.3),0 6px 20px 0 rgba(0,0,0,.3)!important;
        box-shadow: 0 4px 8px 0 rgba(0,0,0,.3),0 6px 20px 0 rgba(0,0,0,.3)!important;
    }

    a {
        width:36px;
        height:36px;
        background-image: url("~images/tool_icon_set.png");
        background-size:432px 108px;
    }

    #btn-toggle-pen-options {
        background-position: -396px 0;
    }

    #btn-toggle-highlighter-options {
        background-position: 0 -36px;
    }

    #btn-toggle-note-options {
        background-position: -36px -72px;
    }

    #btn-toggle-eraser-options {
        background-position: 0 -72px;
    }


</style>